const addToCartError = {
    GENERAL_CART_ERROR: 'GENERAL_CART_ERROR',
    MIXED_SHOPPING_ERROR: 'MIXED_SHOPPING_ERROR',
    // @TODO: add cookie warning like in PDP.
    // COOKIE_WARNING: 'COOKIE_WARNING',
};

export { addToCartError };
